import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSession } from "../../api/sessionManagement";
import { Trans } from "react-i18next";
import "./NotFoundPage.sass";

export const NotFoundPage: React.FC = () => {
  const [isActiveSession, setIsActiveSession] = useState(false);

  useEffect(() => {
    if (getSession()) {
      setIsActiveSession(true);
    } else {
      setIsActiveSession(false);
    }
  }, []);
  return (
    <>
      {isActiveSession ? (
        <div className="error-container">
          <h2>
            <Trans i18nKey="noResultsFound" />
          </h2>
          <p>
            <Trans i18nKey="tryDifferentSearch" />{" "}
            <Link className="error-link" to="/">
              <Trans i18nKey="mainPage" />
            </Link>
          </p>
        </div>
      ) : (
        <div className="error-container">
          <h2>
            <Trans i18nKey="pageNotFound" />
          </h2>
          <p>
            <Trans i18nKey="pageNotExists" />
          </p>
          <Link to="/sign-in" className="error-link">
            <Trans i18nKey="goToSignIn" />
          </Link>
        </div>
      )}
    </>
  );
};
